// Drop official assets into /public/brand/ and set the paths below (null = placeholder shown).
export const BRAND = {
  siteUrl: "https://synrise.site",
  logo: "/brand/synrise-logo.webp",
  logoSmall: "/brand/synrise-logo-sm.webp",
  shareUrl: "", // empty = current site URL
  // Privacy policy details: fill in to replace the [placeholders] on /privacy-policy
  legal: { controller: "Abdelouahed El Allali", email: "synrise@synrise.pro" },
  partners: [
    { id: "befive", name: "Be Five%", logo: "/brand/befive-logo.webp" },
    { id: "risevision", name: "RiseVision", logo: "/brand/risevision-logo.webp", fade: true },
  ],
};

// Empty = shows a "link coming soon" notice instead of opening.
export const LINKS = {
  etoro: "https://med.etoro.com/B10215_A126626_TClick.aspx",
  telegram: "https://t.me/SYNrise_pro",
  instagram: "https://www.instagram.com/abdul22_2?stkn=MXZobXd6d2hvMnF0cw%3D%3D&utm_source=qr",
  website: "https://synrise.pro",
  trustpilot: "https://it.trustpilot.com/evaluate/synrise.pro",
};
